import React, { useState } from 'react'
import { PRGlassProperties } from '@sketch-hq/sketch-web-renderer'
import { Popover } from '@sketch/components'
import { copyGlass } from './copy'
import {
  AttributeList,
  FullCopyAttribute,
  Header,
  SubTitle,
} from '../../../components'
import { GlassPopover } from './GlassPopover'
import { getDirtyAttributes } from '../../../components/Style'
import { ExpandIcon, HoverContainer } from './Blur.styles'

interface GlassPropsWithDirtyValues extends PRGlassProperties {
  originalValues?: PRGlassProperties
}

/**
 * Glass is a specific type of blur
 * and shares styles with Blur as well
 */
export const Glass = ({
  originalValues,
  ...props
}: GlassPropsWithDirtyValues) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false)

  const sectionCopyValue = copyGlass({
    ...props,
  })

  const handlePopoverClose = () => {
    setPopoverOpen(false)
  }

  return (
    <>
      <Popover
        visible={isPopoverOpen}
        placement="left"
        popup={
          <GlassPopover
            {...props}
            copyValue={sectionCopyValue}
            onClose={handlePopoverClose}
          />
        }
        spacing="16px"
        data-testid="glass-popover"
        onClickOutside={handlePopoverClose}
      >
        <HoverContainer
          onClick={() => setPopoverOpen(!isPopoverOpen)}
          visible={isPopoverOpen}
        >
          <Header
            dirtyAttributes={getDirtyAttributes({
              originalValueKey: 'isCustom',
              valueToDisplay: originalValues?.isCustom ? 'Custom' : 'Default',
              originalValues,
              labelToDisplay: 'Custom Glass',
            })}
          >
            <SubTitle>Glass</SubTitle>
          </Header>
          <ExpandIcon />
        </HoverContainer>
      </Popover>
      <AttributeList>
        <FullCopyAttribute
          label="Type"
          value={props.isCustom ? 'Custom' : 'Default'}
          dirtyAttributes={getDirtyAttributes({
            originalValueKey: 'isCustom',
            valueToDisplay: originalValues?.isCustom ? 'Custom' : 'Default',
            originalValues,
            labelToDisplay: 'Type',
          })}
        />
      </AttributeList>
    </>
  )
}
